export function getInitials(value: string, fallback = 'NA'): string {
  const parts = value
    .split(/\s+/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  }

  const first = parts[0] ?? '';
  if (!first) return fallback.toUpperCase();
  return first.slice(0, 2).toUpperCase();
}
